// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.removeRightPadding__a98.removeRightPadding__a98 {
  padding-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/cwm-sessions/date-filters.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".removeRightPadding.removeRightPadding {\n  padding-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"removeRightPadding": `removeRightPadding__a98`
};
export default ___CSS_LOADER_EXPORT___;
